import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const MANUAL = "__manual__";

/* clientId (optional): main-client users pick which client's portfolio to show — "" = every client in the family. */
export function PropertyPicker({ value, onChange, allowManual = true, clientId = "" }) {
  const [all, setAll] = useState([]);
  useEffect(() => {
    API.get("/client-hub/properties").then(({ data }) => setAll(data.properties || [])).catch(() => {});
  }, []);
  const props = clientId ? all.filter((p) => p.client_id === clientId) : all;
  return (
    <div className="space-y-1">
      <Select value={value || (allowManual ? MANUAL : "")} onValueChange={(v) => onChange(v === MANUAL ? "" : v, props.find((p) => p.id === v) || null)}>
        <SelectTrigger data-testid="property-picker"><SelectValue placeholder="Choose a property" /></SelectTrigger>
        <SelectContent>
          {props.map((p) => (
            <SelectItem key={p.id} value={p.id} data-testid={`property-option-${p.id}`}>{p.name} — {p.postcode}{p.for_client && !clientId ? ` (${p.for_client})` : ""}</SelectItem>
          ))}
          {allowManual && <SelectItem value={MANUAL} data-testid="property-option-manual">Enter an address manually…</SelectItem>}
        </SelectContent>
      </Select>
      {props.length === 0 && (
        <p className="text-[11px] text-muted-foreground">No saved properties yet — <Link to="/portal/properties" className="text-primary hover:underline">add your sites</Link> to pick them in one click next time.</p>
      )}
    </div>
  );
}
